// src/config/google.ts

import { getEnv, isProduction, getApiBaseUrl, getRedirectUri } from '../utils/environment';
import { getGoogleClientId } from '../utils/backendConfig';

/**
 * Google OAuth2 Configuration - Updated for Backend Integration
 * 
 * SECURITY UPDATE: Google client ID now fetched from backend API at runtime
 * instead of being stored in frontend environment variables.
 * 
 * This provides better security by:
 * - Keeping sensitive data on the backend only
 * - Fetching public configuration at runtime
 * - Reducing attack surface of frontend bundle
 */

/**
 * Get Google client ID from backend configuration
 * This replaces the old environment variable approach
 */
export async function getGoogleConfig() {
  const clientId = await getGoogleClientId();
  
  return {
    // Google OAuth2 Client ID fetched from backend
    clientId: clientId || '', // Fallback to empty string if not available
  
    // OAuth2 Redirect URI
    // This must match the redirect URI configured in the Google Cloud Console
    redirectUri: getRedirectUri('google'),
    
    // API Endpoint for backend communication
    apiEndpoint: getApiBaseUrl(),
    
    // OAuth2 Scopes required by the application
    scopes: [
      'profile',        // Get basic profile info
      'email',          // Access user's email address
      'openid'          // OpenID Connect support
    ],
  };
}

/**
 * Google API Routes
 * These routes should match the endpoints exposed by your backend
 */
export const googleApiRoutes = {
  // Authentication
  auth: {
    token: '/auth/google/token',
    refresh: '/auth/google/refresh',
    logout: '/auth/google/logout'
  },
  
  // User
  user: {
    profile: '/user/profile',
    settings: '/user/settings'
  }
};

export default getGoogleConfig;